import type { FaireProductEntity } from "../../entity_types/product";

export const p_b2625tgcjx: FaireProductEntity = {
  token: "p_b2625tgcjx",
  type: "product",
  name: "Cool Aunt Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/34265f2df447c006f3a196e75df9d578b1b262706087bde40e2f247cf158e233.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed27463f445370015b74e9cc801e9b73470c9328bdf53046313dbd1376bb890d.jpeg",
    "https://cdn.faire.com/fastly/4d60441d160119da92358e25eb7a37149e4680d234b65816d9eec0e36f5af41b.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/d80dba076b98f839716b1cd453615cc5886782cd388d8de73594a5202c56a27e.jpeg",
    "https://cdn.faire.com/fastly/077d474bc237c098c4b572f120a058cd1ccd407255bbc67132991c88e5da0dde.jpeg"
  ],
  priceDollars: 6.75,
  description: "Get the socks perfect for the fun-loving, rule-bending, starts-drinking-early-at-family-parties aunt in your life. They deserve these.💕\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:52.169Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
